/****************************************************
 * Module Name:  userProxy.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import restAPICall from "../../api/restAPICall";
import Constants from "../../constants";

export default class UserProfileProxy {
  static GetAllUserProfile = (callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/userprofile",
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetSingleUserProfile = (userId, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/userprofile/${userId}`,
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static AddUserProfile = (user, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/userprofile",
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(user),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static UpdateUserProfile = (user, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/userprofile",
      "put",
      Constants.userToken,
      undefined,
      JSON.stringify(user),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static AddProfilePhoto = (userId, data, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/userprofile/upload/${userId}`,
      "post",
      Constants.userToken,
      undefined,
      data,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static RemoveProfilePhoto = (userId, data, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/userprofile/upload/${userId}`,
      "delete",
      Constants.userToken,
      undefined,
      data,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetUserProfilePhotoByID = (userId, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/userprofile/photo/${userId}`,
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static isUserStatePresent = (userId, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/userprofile/state/${userId}`,
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

}
